import { render, staticRenderFns } from "./clockworkMini.vue?vue&type=template&id=06d5b898&"
import script from "./clockworkMini.vue?vue&type=script&lang=ts&"
export * from "./clockworkMini.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports